import {
  Button,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useRecoilCallback, useRecoilValue, useResetRecoilState } from 'recoil'

import modalMessageRedirect from 'Helpers/modalMessageRedirect'
import { exitCallback } from 'Pages/Campaign/recoil/callbacks/callbackEditBee'
import { editorState } from 'Pages/Campaign/recoil/state/bee'
import { modalConcurrentAccess } from 'Pages/Campaign/recoil/state/modals'

export const ModalConcurrentAccess = () => {
  const intl = useIntl()
  const history = useHistory()

  const { show } = useRecoilValue(modalConcurrentAccess)
  const resetModal = useResetRecoilState(modalConcurrentAccess)
  const exit = useRecoilCallback(exitCallback, [])
  const { concurrentAccessUsername } = useRecoilValue(editorState)
  const { redirect } = modalMessageRedirect(history)
  const handleClose = () => {
    resetModal()
    exit(
      false,
      (messageType) => {
        redirect(messageType)
      },
      true
    )
  }

  return (
    <Modal
      show={show}
      showClose={false}
      closeOnOverlayClick={false}
      data-mu-test='modal-message-concurrent-access'
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.Bee.ModalTitleForModOtherUsers'
        })}
      />
      <ModalBody>
        {intl.formatMessage(
          {
            id: 'Load.Bee.ModalDescrForModOtherUsers'
          },
          {
            strong: (content) => (
              <strong key='concurrentAccessUsername'>{content}</strong>
            ),
            NOME: concurrentAccessUsername
          }
        )}
      </ModalBody>
      <ModalFoot>
        <Button
          data-mu-test='button-message-concurrent-access'
          onClick={handleClose}
          kind='primary'
        >
          {intl.formatMessage({
            id: 'Load.Bee.ModalForContinueEditingTemplatePreviewCloseBtn'
          })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}
